import type { ComputedRef } from "vue";
import { resolveBuildingBlockDebug } from "#bb/lib/buildingBlockDebug";

export interface BuildingBlockDebugFeatures {
  debugBuildingBlocks?: boolean;
}

export function useBuildingBlockDebug(
  definitionData: ComputedRef<{ debug?: boolean } | null | undefined>,
  features: BuildingBlockDebugFeatures,
  loggerName: string,
) {
  const state = computed(() => resolveBuildingBlockDebug({
    blockDebug: definitionData.value?.debug,
    resourceDebug: features.debugBuildingBlocks,
  }));

  function log(event: string, payload: Record<string, unknown>) {
    if (!import.meta.client || !state.value.enabled) return;

    const snapshot = {
      debugSource: state.value.source,
      ...payload,
    };
    console.groupCollapsed(
      `[BuildingBlocks:${loggerName}] ${event}`,
    );
    console.debug(snapshot);
    console.debug("Copyable snapshot", JSON.stringify(snapshot, null, 2));
    console.groupEnd();
  }

  return {
    enabled: computed(() => state.value.enabled),
    source: computed(() => state.value.source),
    log,
  };
}
